/**
 * IDs de columnas/filtros ocultos compartidos por los dos listados del RV
 * (Recorregut de Vigilància): el listado activo
 * (`GeneralViewRoute/SurveillanceRoutesPage`) y el histórico
 * (`SearchAndCreateHistoricalRoute`). Extraído de la duplicación idéntica
 * de estos dos arrays que existía por separado en cada página (auditoría
 * 2026-07-07, Task 2 del refactor de patrones RV).
 */

// V4 FR-1.6: el RV no usa Capítulo/Subcapítulo/Predefinidos/Tipo vial
// (track)/Sentido (direction)/Fecha sistema (creationDate). Ocultarlos
// hasta que se complete el refactor del adapter (FR-1.8).
// Fix 2026-07-04 (feedback usuario, "la tabla se sale"): Descripción
// duplica el Nombre del recorrido y Creador llega vacío del adapter
// — fuera ambas para que la tabla encaje como las canónicas.
//
// 2026-08-04: Descripción VUELVE (petición usuario). Las dos razones de
// entonces han caducado: el Recorrido tiene su propia casilla de Descripción
// en el formulario —distinta del Nombre— y 39 de 59 recorridos de beta la
// tienen escrita; y el filtro por descripción del panel SÍ estaba visible, así
// que se podía buscar por un campo que no se veía. `user` sigue fuera: el
// creador se pinta con la columna propia del RV (`creator`, 2026-07-17).
export const SR_HIDDEN_COLUMN_IDS = [
  'capitol',
  'subCapitol',
  'predefinedOrder',
  'track',
  'direction',
  'creationDate',
  'user',
];

// V4 FR-1.5: el panel de filtros del RV no usa estos inputs.
// 2026-07-17: 'creator' ya NO se oculta — el backend RV acepta `userIds`
// (filtro Creador sobre SurveillanceRoute.userId, Tipo B denormalizado,
// DISTINTO de `operatorIds`/participantes) y el RV muestra ambos dropdowns
// (Creador multi-select + Operarios multi-select).
export const SR_HIDDEN_FILTER_IDS = [
  'capitol',
  'subCapitol',
  'predefinedOrder',
  'track',
  'classification',
];
